module.exports = __webpack_public_path__ + "static/media/profile1.46174502.png";